
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accounts/[address]/settings/notifications",
      function () {
        return require("private-next-pages/accounts/[address]/settings/notifications.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accounts/[address]/settings/notifications"])
      });
    }
  